import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TopBarComponent} from './components/top-bar/top-bar.component';
import {TranslationComponent} from './components/translation/translation.component';
import {BreadcrumbComponent} from './components/top-bar/breadcrumb/breadcrumb.component';
import {FrontBaseAngularCoreModule} from 'front-base-angular-core/angular/projects/front-base-angular-core/src/public-api';
import {NavSidebarComponent} from './components/nav-sidebar/nav-sidebar.component';
import {TranslateModule} from '@ngx-translate/core';
import {FormsModule} from '@angular/forms';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {HttpAuthorizationInterceptor} from '@interceptors/http.interceptor';
import {ToastrModule} from 'ngx-toastr';
import {TopBarUserComponent} from './components/top-bar/top-bar-user/top-bar-user.component';
import {BottomBarComponent} from '@shared/components/bottom-bar/bottom-bar.component';
import {SubmitDirective} from '@shared/directives/submit.directive';
import {PreventDoubleClickDirective} from '@shared/directives/prevent-double-click';
import {UnsavedChangesDialogComponent} from './components/unsaved-changes-dialog/unsaved-changes-dialog.component';
import {BarMenuComponent} from './components/bar-menu/bar-menu.component';
import {SecureDirective} from './directives/secure.directive';
import {DeleteIconComponent} from './components/icons/delete-icon/delete-icon.component';
import {DeleteButtonComponent} from './components/buttons/delete-button/delete-button.component';
import {StorageExtDirective} from './directives/storage-ext.directive';
import {ConfirmActionDialogComponent} from './components/dialogs/confirm-action-dialog/confirm-action-dialog.component';
import {ConfirmActionDialogIconComponent} from './components/icons/confirm-action-dialog-icon/confirm-action-dialog-icon.component';
import {UserInactivityComponent} from './components/user-inactivity/user-inactivity.component';
import {HistoryBackIconComponent} from './components/icons/history-back-icon/history-back-icon.component';
import {InfoDialogComponent} from './components/dialogs/info-dialog/info-dialog.component';
import {
  AppoAppointmentHighlightComponent
} from './components/appo-appointment/appo-appointment-highlight/appo-appointment-highlight.component';
import {
  AttentionsUpcomingComponent
} from '@shared/components/attentions-upcoming/attentions-upcoming.component';
import {PatientBarComponent} from './components/patient-bar/patient-bar.component';
import {GetYearsPipe} from './pipes/get-years.pipe';
import {PasiWizardComponent} from './components/pasi-wizard/pasi-wizard.component';
import {GrayCardComponent} from './components/gray-card/gray-card.component';
import {ChatComponent} from './components/chat/chat.component';
import {GooglePlaceModule} from 'ngx-google-places-autocomplete';
import {GoogleMapsModule} from '@angular/google-maps';
import {MapsComponent} from './components/maps/maps.component';
import {GoogleAddressSearcher} from './components/google-searcher/si-google-address-searcher.component';
import {AccessibilityDialogDirective} from './directives/accessibility-dialog.directive';
import {PwaInstallBannerComponent} from './components/pwa-install-banner/pwa-install-banner.component';
import {GenericDialogComponent} from './components/dialogs/generic-dialog/generic-dialog.component';
import {LinkPatientWarningComponent} from './components/link-patient-warning/link-patient-warning.component';
import {LinkPatientPageComponent} from './components/link-patient/link-patient-page/link-patient-page.component';
import {FullCalendarModule} from '@fullcalendar/angular';
import {RoleChangePageComponent} from './components/role-change-page/role-change-page.component';
import {StatesCaptionComponent} from './components/states-caption/states-caption.component';
import {DiDiaryComponent} from '@shared/components/di-diary/di-diary.component';
import {SameDayPipe} from './pipes/same-day.pipe';
import {ChartModule} from 'primeng/chart';
import {VitVitalSignChartComponent} from './components/vit-vital-sign/vit-vital-sign-chart/vit-vital-sign-chart.component';
import {
  VitVitalSignChartParentComponent
} from './components/vit-vital-sign/vit-vital-sign-chart-parent/vit-vital-sign-chart-parent.component';
import {GoBackButtonComponent} from './components/go-back-button/go-back-button.component';
import {NotificationBoxIconComponent} from './components/icons/notification-box-icon/notification-box-icon.component';
import {
  MtestMedicalTestDownloadIconComponent
} from './components/mtest-medical-test/mtest-medical-test-download-icon/mtest-medical-test-download-icon.component';
import {
  MtestMedicalTestDownloadIconsComponent
} from './components/mtest-medical-test/mtest-medical-test-download-icons/mtest-medical-test-download-icons.component';
import {MtestMedicalTestIconComponent} from './components/mtest-medical-test/mtest-medical-test-icon/mtest-medical-test-icon.component';
import {MtestMedicalTestItemComponent} from './components/mtest-medical-test/mtest-medical-test-item/mtest-medical-test-item.component';
import {
  MtestMedicalTestItemResultsComponent
} from './components/mtest-medical-test/mtest-medical-test-item-results/mtest-medical-test-item-results.component';
import {
  MtestMedicalTestImageIconComponent
} from './components/mtest-medical-test/mtest-medical-test-image-icon/mtest-medical-test-image-icon.component';
import {EnvironmentDirective} from './directives/environment.directive';
import {GenericFiltersComponent} from './components/generic-filters/generic-filters.component';
import {FiltersToQueryPipe} from './pipes/filters-to-query.pipe';
import {FaqIconComponent} from './components/icons/faq-icon/faq-icon.component';
import {SmsVerificationDialogComponent} from './components/sms-verification-dialog/sms-verification-dialog.component';
import {EmailVerificationDialogComponent} from './components/email-verification-dialog/email-verification-dialog.component';
import {VerificationParentComponent} from './components/verification-parent/verification-parent.component';
import {FaqPageComponent} from './components/faq-page/faq-page.component';
import {NgxUiTourComponent} from './components/ngx-ui-tour/ngx-ui-tour.component';
import {TourNgxBootstrapModule} from 'ngx-ui-tour-ngx-bootstrap';
import {VerticalMenuExtComponent} from './components/vertical-menu-ext/vertical-menu-ext.component';
import {MedMedicationItemComponent} from './components/med-medication-item/med-medication-item.component';
import {FrequencyStringPipe} from './pipes/frequency-string.pipe';
import {HealthInsuranceSelectorComponent} from './components/health-insurance-selector/health-insurance-selector.component';
import {HealthInsuranceAddButtonComponent} from './components/health-insurance-add-button/health-insurance-add-button.component';
import {AppoArrivalTurnDialogComponent} from './components/appo-appointment/appo-arrival-turn-dialog/appo-arrival-turn-dialog.component';
import {AppoArrivalConfirmButtonComponent} from './components/appo-appointment/appo-arrival-confirm-button/appo-arrival-confirm-button.component';
import {AppoArrivalConfirmDialogComponent} from './components/appo-appointment/appo-arrival-confirm-dialog/appo-arrival-confirm-dialog.component';
import {AppoArrivalTurnItemComponent} from './components/appo-appointment/appo-arrival-turn-item/appo-arrival-turn-item.component';
import {GenericAlertComponent} from './components/generic-alert/generic-alert.component';
import {ConcatArrayPipe} from './pipes/concat-array.pipe';
import {ShareDialogComponent} from './components/dialogs/share-dialog/share-dialog.component';
import {QRCodeModule} from 'angularx-qrcode';
import {AppoAttendanceConfirmButtonComponent} from './components/appo-appointment/appo-attendance-confirm-button/appo-attendance-confirm-button.component';
import {AppoAttendanceConfirmDialogComponent} from './components/appo-appointment/appo-attendance-confirm-dialog/appo-attendance-confirm-dialog.component';
import {PresPrescriptionItemComponent} from './components/pres-prescription-item/pres-prescription-item.component';
import {InterInterventionItemComponent} from './components/inter-intervention-item/inter-intervention-item.component';
import {AppoRequestIconComponent} from './components/icons/appo-request-icon/appo-request-icon.component';
import {AppoAppointmentRequestPageComponent} from './components/appo-appointment/appo-appointment-request-page/appo-appointment-request-page.component';
import {AppoAppointmentRequestRequirementsComponent} from './components/appo-appointment/appo-appointment-request-requirements/appo-appointment-request-requirements.component';
import {AppoAppointmentRequestDateComponent} from './components/appo-appointment/appo-appointment-request-date/appo-appointment-request-date.component';
import {AppoAppointmentRequestIdentificationComponent} from './components/appo-appointment/appo-appointment-request-identification/appo-appointment-request-identification.component';
import {AppoAppointmentRequestConfirmDateComponent} from './components/appo-appointment/appo-appointment-request-confirm-date/appo-appointment-request-confirm-date.component';
import {AppoAppointmentRequestFinishComponent} from './components/appo-appointment/appo-appointment-request-finish/appo-appointment-request-finish.component';
import {AppoAppointmentRequestFinishErrorComponent} from './components/appo-appointment/appo-appointment-request-finish-error/appo-appointment-request-finish-error.component';
import {AppoNoAvailableDatesDialogComponent} from './components/appo-appointment/appo-no-available-dates-dialog/appo-no-available-dates-dialog.component';
import {AppoAppointmentProofComponent} from './components/appo-appointment/appo-appointment-proof/appo-appointment-proof.component';
import {LoginDialogComponent} from './components/dialogs/login-dialog/login-dialog.component';
import {AutofillListenerDirective} from './directives/autofill-listener.directive';
import {RegisterPersonalDataComponent} from './components/register-personal-data/register-personal-data.component';
import {RegisterPasswordComponent} from './components/register-password/register-password.component';
import {RegisterPrivacyComponent} from './components/register-privacy/register-privacy.component';

@NgModule({
  declarations: [
    TopBarComponent,
    TranslationComponent,
    BreadcrumbComponent,
    NavSidebarComponent,
    TopBarUserComponent,
    BottomBarComponent,
    SubmitDirective,
    PreventDoubleClickDirective,
    UnsavedChangesDialogComponent,
    BarMenuComponent,
    SecureDirective,
    AccessibilityDialogDirective,
    AutofillListenerDirective,
    DeleteIconComponent,
    DeleteButtonComponent,
    StorageExtDirective,
    ConfirmActionDialogComponent,
    ConfirmActionDialogIconComponent,
    UserInactivityComponent,
    HistoryBackIconComponent,
    InfoDialogComponent,
    AppoAppointmentHighlightComponent,
    AttentionsUpcomingComponent,
    PatientBarComponent,
    GetYearsPipe,
    PasiWizardComponent,
    GrayCardComponent,
    ChatComponent,
    MapsComponent,
    GoogleAddressSearcher,
    PwaInstallBannerComponent,
    GenericDialogComponent,
    LinkPatientWarningComponent,
    LinkPatientPageComponent,
    RoleChangePageComponent,
    StatesCaptionComponent,
    DiDiaryComponent,
    SameDayPipe,
    VitVitalSignChartComponent,
    VitVitalSignChartParentComponent,
    GoBackButtonComponent,
    NotificationBoxIconComponent,
    MtestMedicalTestItemComponent,
    MtestMedicalTestItemResultsComponent,
    MtestMedicalTestDownloadIconComponent,
    MtestMedicalTestDownloadIconsComponent,
    MtestMedicalTestIconComponent,
    MtestMedicalTestImageIconComponent,
    EnvironmentDirective,
    GenericFiltersComponent,
    FiltersToQueryPipe,
    FaqIconComponent,
    SmsVerificationDialogComponent,
    EmailVerificationDialogComponent,
    VerificationParentComponent,
    FaqPageComponent,
    NgxUiTourComponent,
    VerticalMenuExtComponent,
    MedMedicationItemComponent,
    FrequencyStringPipe,
    HealthInsuranceSelectorComponent,
    HealthInsuranceAddButtonComponent,
    AppoArrivalTurnDialogComponent,
    AppoArrivalConfirmButtonComponent,
    AppoArrivalConfirmDialogComponent,
    AppoArrivalTurnItemComponent,
    AppoAppointmentRequestPageComponent,
    AppoAppointmentRequestRequirementsComponent,
    AppoAppointmentRequestDateComponent,
    AppoAppointmentRequestIdentificationComponent,
    AppoAppointmentRequestConfirmDateComponent,
    AppoAppointmentRequestFinishComponent,
    AppoAppointmentRequestFinishErrorComponent,
    AppoNoAvailableDatesDialogComponent,
    AppoAppointmentProofComponent,
    GenericAlertComponent,
    ConcatArrayPipe,
    ShareDialogComponent,
    AppoAttendanceConfirmButtonComponent,
    AppoAttendanceConfirmDialogComponent,
    PresPrescriptionItemComponent,
    InterInterventionItemComponent,
    AppoRequestIconComponent,
    LoginDialogComponent,
    RegisterPersonalDataComponent,
    RegisterPasswordComponent,
    RegisterPrivacyComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    FrontBaseAngularCoreModule,
    TranslateModule,
    ToastrModule.forRoot(),
    GooglePlaceModule,
    GoogleMapsModule,
    FullCalendarModule,
    ChartModule,
    TourNgxBootstrapModule.forRoot(),
    QRCodeModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpAuthorizationInterceptor,
      multi: true
    }
  ],
  exports: [
    FormsModule,
    FrontBaseAngularCoreModule,
    TranslateModule,
    TopBarComponent,
    TranslationComponent,
    BreadcrumbComponent,
    NavSidebarComponent,
    BottomBarComponent,
    SubmitDirective,
    PreventDoubleClickDirective,
    UnsavedChangesDialogComponent,
    SecureDirective,
    AccessibilityDialogDirective,
    AutofillListenerDirective,
    DeleteIconComponent,
    DeleteButtonComponent,
    StorageExtDirective,
    ConfirmActionDialogComponent,
    ConfirmActionDialogIconComponent,
    UserInactivityComponent,
    HistoryBackIconComponent,
    InfoDialogComponent,
    AppoAppointmentHighlightComponent,
    AttentionsUpcomingComponent,
    PatientBarComponent,
    GetYearsPipe,
    PasiWizardComponent,
    GrayCardComponent,
    // ChatComponent,
    GooglePlaceModule,
    GoogleMapsModule,
    MapsComponent,
    GoogleAddressSearcher,
    PwaInstallBannerComponent,
    GenericDialogComponent,
    LinkPatientWarningComponent,
    LinkPatientPageComponent,
    FullCalendarModule,
    StatesCaptionComponent,
    DiDiaryComponent,
    SameDayPipe,
    ChartModule,
    VitVitalSignChartParentComponent,
    GoBackButtonComponent,
    MtestMedicalTestItemComponent,
    MtestMedicalTestItemResultsComponent,
    MtestMedicalTestDownloadIconComponent,
    MtestMedicalTestDownloadIconsComponent,
    MtestMedicalTestIconComponent,
    MtestMedicalTestImageIconComponent,
    EnvironmentDirective,
    GenericFiltersComponent,
    FiltersToQueryPipe,
    SmsVerificationDialogComponent,
    EmailVerificationDialogComponent,
    VerificationParentComponent,
    FaqPageComponent,
    NgxUiTourComponent,
    MedMedicationItemComponent,
    FrequencyStringPipe,
    HealthInsuranceSelectorComponent,
    HealthInsuranceAddButtonComponent,
    AppoArrivalTurnDialogComponent,
    AppoArrivalConfirmButtonComponent,
    AppoArrivalConfirmDialogComponent,
    AppoArrivalTurnItemComponent,
    AppoAppointmentRequestPageComponent,
    AppoAppointmentRequestRequirementsComponent,
    GenericAlertComponent,
    ConcatArrayPipe,
    ShareDialogComponent,
    QRCodeModule,
    AppoAttendanceConfirmButtonComponent,
    AppoAttendanceConfirmDialogComponent,
    PresPrescriptionItemComponent,
    InterInterventionItemComponent,
    RegisterPersonalDataComponent,
    RegisterPasswordComponent,
    RegisterPrivacyComponent
  ]
})
export class SharedModule {
}
